export default __webpack_public_path__ + "media/images/brands/demo/services/service-06-514bd020cbceb53e3aa8404088b32182.jpg";